import styled from 'styled-components';

import { CheckItem } from 'doctornow-design-system';

export interface QnaWriteAdditionalInfoProps {
  onClickCheckPregnant: () => void;
  pregnant: boolean;
}

const QnaWriteAdditionalInfo = ({ onClickCheckPregnant, pregnant }: QnaWriteAdditionalInfoProps) => {
  return (
    <Wrapper>
      <CheckItem
        label='현재 임신 중입니다.'
        checkboxProps={{ checked: pregnant, onCheckedChange: onClickCheckPregnant }}
      />
    </Wrapper>
  );
};

export default QnaWriteAdditionalInfo;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  & > button {
    border: none;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0;

    & > p {
      ${({ theme }) => theme.typography.UI16M};
      color: ${({ theme }) => theme.color.gray400};
    }
  }

`;
